import SegmentsService from '../../services/segments.service'
import segmentTypes from '../types/segments'
import constants from '../../constants'

const FetchSegmentsRequest = () => ({ type: segmentTypes.FETCH_SEGMENTS_REQUEST, payload: null })
const FetchSegmentsError = error => ({ type: segmentTypes.FETCH_SEGMENTS_ERROR, payload: error })
const FetchSegmentsSuccess = payload => ({ type: segmentTypes.FETCH_SEGMENTS_SUCCESS, payload })

export const fetchSegments = sessionId => dispatch => {
  dispatch(FetchSegmentsRequest())
  SegmentsService.fetchSegments(sessionId)
    .then(response => dispatch(FetchSegmentsSuccess(response)))
    .catch(error => dispatch(FetchSegmentsError(error)))
}

const CreateSegmentRequest = () => ({ type: segmentTypes.CREATE_SEGMENT_REQUEST, payload: null })
const CreateSegmentError = error => ({ type: segmentTypes.CREATE_SEGMENT_ERROR, payload: error })
const CreateSegmentSuccess = payload => ({ type: segmentTypes.CREATE_SEGMENT_SUCCESS, payload })

export const createSegment = segment => dispatch => {
  dispatch(CreateSegmentRequest())
  SegmentsService.postSegment(constants.session.getId(), segment)
    .then(response => {
      dispatch(CreateSegmentSuccess(response))
      dispatch(fetchSegments(constants.session.getId()))
    })
    .catch(error => dispatch(CreateSegmentError(error)))
}

const UpdateSegmentRequest = () => ({ type: segmentTypes.UPDATE_SEGMENT_REQUEST, payload: null })
const UpdateSegmentError = error => ({ type: segmentTypes.UPDATE_SEGMENT_ERROR, payload: error })
const UpdateSegmentSuccess = payload => ({ type: segmentTypes.UPDATE_SEGMENT_SUCCESS, payload })

export const updateSegment = (segmentId, segment) => dispatch => {
  dispatch(UpdateSegmentRequest())
  SegmentsService.putSegment(constants.session.getId(), segmentId, segment)
    .then(response => {
      dispatch(UpdateSegmentSuccess(response))
      dispatch(fetchSegments(constants.session.getId()))
    })
    .catch(error => dispatch(UpdateSegmentError(error)))
}

const DeleteSegmentRequest = () => ({ type: segmentTypes.DELETE_SEGMENT_REQUEST, payload: null })
const DeleteSegmentError = error => ({ type: segmentTypes.DELETE_SEGMENT_ERROR, payload: error })
const DeleteSegmentSuccess = segmentId => ({ type: segmentTypes.DELETE_SEGMENT_SUCCESS, payload: segmentId })

export const deleteSegment = segmentId => dispatch => {
  dispatch(DeleteSegmentRequest())
  SegmentsService.delSegment(constants.session.getId(), segmentId)
    .then(() => dispatch(DeleteSegmentSuccess(segmentId)))
    .catch(error => dispatch(DeleteSegmentError(error)))
}

export const setSelectedSegment = segment => ({
  type: segmentTypes.SET_SELECTED_SEGMENT,
  payload: segment
})

export const setSegmentOpen = (open, segment = null) => ({
  type: segmentTypes.SET_SEGMENT_OPEN,
  payload: { open, segment }
})

export const confirmSegmentDelete = open => ({
  type: segmentTypes.CONFIRM_SEGMENT_DELETE,
  payload: open
})
